'use client';

import React from 'react';
import posthog from 'posthog-js';

interface FooterLinkProps {
	href: string;
	children: React.ReactNode;
	onClick?: () => void; // <-- Add this line
}

interface FooterProps {
	showSignIn?: boolean;
}

const ExternalLink: React.FC<FooterLinkProps> = ({ href, children, onClick }) => (
	<a
		href={href}
		target="_blank"
		className="text-base font-semibold text-grey-800 hover:text-grey-600 hover:underline"
		rel="noreferrer"
		onClick={onClick}
	>
		{children}
	</a>
);

const NavLink: React.FC<FooterLinkProps> = ({ href, children, onClick }) => (
	<a
		href={href}
		className="text-base font-semibold text-grey-800 hover:text-grey-600 hover:underline"
		onClick={onClick}
	>
		{children}
	</a>
);

const LoginFooter: React.FC<FooterProps> = ({ showSignIn = false }) => {
	const links = [
		{
			href: 'mailto:support@praxislabs.co',
			text: 'Need Help?',
		},
		{
			href: 'https://praxislabs.co/privacy',
			text: 'Privacy Policy',
		},
		{
			href: 'https://praxislabs.co/terms-of-service',
			text: 'Terms Of Service',
		},
	];

	return (
		<div className="flex justify-center space-x-5 py-4">
			<NavLink
				onClick={() =>
					posthog.capture(`${(showSignIn ? 'Sign In' : 'Sign Up').toLowerCase().replace(/\s+/g, '_')}_button_clicked`)
				}
				href={showSignIn ? '/login' : '/register'}
			>
				{showSignIn ? 'Sign In' : 'Sign Up'}
			</NavLink>

			{links.map((link) => (
				<ExternalLink
					onClick={() => posthog.capture(`${link.text.toLowerCase().replace(/\s+/g, '_')}_button_clicked`)}
					key={link.text}
					href={link.href}
				>
					{link.text}
				</ExternalLink>
			))}
		</div>
	);
};

export default LoginFooter;
